import React from 'react';
import Icon from '../../../../../icons/manualIcon.svg'
import styled from 'styled-components';

const ManualIcon = styled.img`
    margin: 0 auto;
    max-width: 70px;
`;

const ContentWrapper = styled.div`
    text-align: center;
`;

const Link = styled.a`
    text-decoration: unset;
    color: black;
`;

const ManualTab = ({info, name}) => (
    <ContentWrapper>
        <Link
            href={`https://gisonline.pl/company/DRONonLine${name}.pdf`}
            target='_blank'
            rel="noopener noreferrer"
        >
            <ManualIcon src={Icon}/>
            <p>{info}</p>
        </Link>
    </ContentWrapper>
);

export default ManualTab;


// WEBPACK FOOTER //
// ./src/containers/content/grid/userWrapper/manualTab/ManualTab.jsx